export default __webpack_public_path__ + "static/media/Rachel.09193217.png";